/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

//import '../../css/event210621.css'

import "../../css/event220617.css";

import { toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import { isMobile } from "react-device-detect";

class Event202207_pop extends PureComponent {
  state = {
    success: false,
  };
  componentDidMount = () => {
    this._getData();
  };

  _getData = async () => {
    const result = await this._getDataApi();
    const success = result.data[0].success;
    const intReturn = result.data[0].intReturn;
    const list = result.data[0].listData;

    //console.log(success)

    if (intReturn === 0) {
      this.setState({
        list,
        success,
      });

      //alert(list[0].title + '/' + list[1].title + '/' + list[0].idx + '/' + list[0].regDate)
    } else {
      toast.error("주문내역이 존재하지 않습니다.");
    }
  };

  _getDataApi = () => {
    const { apiUrl } = this.props;

    return axios.post(apiUrl + "/event_202207_list", {
      params: {},
    });
  };
  _close = () => {
    const { close } = this.props.childProps;
    close();
  };
  _renderItem = () => {
    const { list } = this.state;
    //console.log(list)
    const lst = list.map((item, index) => {
      return (
        <div className="item" key={index}>
          <a href="#">
            <img src={item.img} />
          </a>
        </div>

        /*
                <div className="item">
                    <div className="thumb"><a href="#"><img src={item.img}/></a></div>
                    <div className="info">
                        <p className="date">
                            <img src="/img/event/event211217/ico_live.png" alt="LIVE"/> {item.liveTime} 첫방송
                        </p>
                        <p className="subject">
                            <a href="#">{item.title}</a>
                        </p>
                    </div>
                </div>
               */
        /*
                <div style={{ color: '#fff'}} key={index}>
                    {item.title}
                </div>
                */
      );
    });

    return lst;
  };
  _go = () => {
    window.open("https://forms.gle/JAEv6sAg2rDkFgxd6", "", "");
  };
  _reset = () => {
    const { reset } = this.props.childProps;
    reset();
  };
  render() {
    const { list, success } =
      this.state; /*success = 0 뽑기성공,  -1 뽑기 실패 */
    //console.log(success)
    return (
      <Fragment>
        <div className="popup">
          <div className="popCont">
            <button type="button" className="pop_close" onClick={this._close}>
              <img src="/img/event/event220617/pop_close.png" />
            </button>
            <ul className="popContainer">
              <li className="user">
                <span>No.{list ? list[0].idx : null} 응모자의 뽑기 결과</span>
              </li>
              <li className="list">{list ? this._renderItem() : null}</li>
              <li className="txt">
                {success === -1 ? (
                  <>
                    <p>
                      <span>축하합니다</span>
                    </p>
                    <p>3분기 신작에 당첨되었습니다!</p>
                    <small>
                      해당 결과를 캡처 후 구글폼에 응모하여 경품을 획득해
                      보세요~!
                    </small>
                  </>
                ) : (
                  <>
                    <p>
                      <span>다음기회에...</span>
                    </p>
                    <p className="fail">
                      재도전으로 다시 한번 당첨을 노려보세요!
                    </p>
                  </>
                )}
              </li>
              <li className="btm">
                {success === -1 ? (
                  <>
                    <a
                      style={{ cursor: "pointer" }}
                      className="link"
                      onClick={this._close}
                    >
                      22.3분기 신작
                      <br />
                      <span>라인업 확인하기</span>
                    </a>
                    <a
                      style={{ cursor: "pointer" }}
                      className="link"
                      onClick={this._go}
                    >
                      뽑기 결과 인증샷
                      <br />
                      <span>구글 폼 응모하기</span>
                    </a>
                  </>
                ) : (
                  <>
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={this._reset}
                      className="link fail"
                    >
                      3분기 신작 뽑기 재도전 하기
                    </a>
                  </>
                )}
              </li>
            </ul>
            <img src="/img/event/event220617/pop_bg.png" />
          </div>
        </div>

        {/*
                <div>
                    <div onClick={this._close}>닫기</div>
                    { list ? this._renderItem() : null }
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202207_pop));
